import {ISearchFilters} from "../types/ISearchFilters";
import {ISearchFiltersFormValues} from "../types/ISearchFiltersFormValues";
import {area} from "./filter_slot_presets/area";
import {constructionEndDate} from "./filter_slot_presets/construction_end_date";
import {price} from "./filter_slot_presets/price";
import {propertyType} from "./filter_slot_presets/property_type";
import {rooms} from "./filter_slot_presets/rooms";

export const mixedSearchFilters: ISearchFilters<ISearchFiltersFormValues> = {
    slots: [propertyType, price, rooms, area, constructionEndDate]
};
import {ISearchFilters} from "../types/ISearchFilters";
import {ISearchFiltersFormValues} from "../types/ISearchFiltersFormValues";
import {area} from "./filter_slot_presets/area";
import {constructionEndDate} from "./filter_slot_presets/construction_end_date";
import {price} from "./filter_slot_presets/price";
import {propertyType} from "./filter_slot_presets/property_type";
import {rooms} from "./filter_slot_presets/rooms";

export const mixedSearchFilters: ISearchFilters<ISearchFiltersFormValues> = {
    slots: [propertyType, price, rooms, area, constructionEndDate]
};
